import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';

const DepartmentAssignedMemberCell = (props: GridCellProps) => {
  const { dataItem } = props;
  const { value } = useGridCellDisplayValue(props);
  const { isDeleted } = dataItem;

  return (
    <GridCellBase {...props} title={value} rowSelectionEnabled>
      <div className="flex items-center">
        <span className="text-ellipsis overflow-hidden">{value}</span>
        {isDeleted && <span className="bg-red-100 ml-2 text-red-700 p-1">Disabled</span>}
      </div>
    </GridCellBase>
  );
};

export default DepartmentAssignedMemberCell;
